import type { TeamMember } from '../types'

export const teamMembers: TeamMember[] = [
  {
    id: 'member-1',
    name: 'Alex Sterling',
    role: 'Founder & Creative Director',
    avatar: '/images/team-01.jpg',
    bio: '15+ years crafting digital experiences. Former design lead at Google, passionate about pushing creative boundaries and building agencies that deliver world-class work.',
    socials: {
      linkedin: 'https://linkedin.com',
      twitter: 'https://twitter.com',
    },
  },
  {
    id: 'member-2',
    name: 'Maya Patel',
    role: 'Lead Developer',
    avatar: '/images/team-02.jpg',
    bio: 'Full-stack architect specializing in React ecosystems and cloud infrastructure. Open source contributor and technical writer for industry publications.',
    socials: {
      linkedin: 'https://linkedin.com',
      github: 'https://github.com',
    },
  },
  {
    id: 'member-3',
    name: 'Lucas Weber',
    role: 'UI/UX Designer',
    avatar: '/images/team-03.jpg',
    bio: 'Award-winning designer with a passion for accessible, human-centered design. Previously designed products used by millions at Spotify and Figma.',
    socials: {
      linkedin: 'https://linkedin.com',
      twitter: 'https://twitter.com',
      github: 'https://github.com',
    },
  },
  {
    id: 'member-4',
    name: 'Sophie Laurent',
    role: 'Project Manager & SEO Strategist',
    avatar: '/images/team-04.jpg',
    bio: 'Certified PMP and SEO specialist with 8+ years delivering complex web projects. Ensures every project ships on time, on budget, and exceeds KPIs.',
    socials: {
      linkedin: 'https://linkedin.com',
      twitter: 'https://twitter.com',
    },
  },
]
